import { useContext } from "react";

import { ShipmentResourcesContext } from "../context/Resources";

export const useBookingResourcesContext = () => {
  const context = useContext(ShipmentResourcesContext);

  return context;
};
